import BasicContentErrorPageHeader from './BasicContentErrorPageHeader';

export { type BasicContentErrorPageHeaderProps } from './BasicContentErrorPageHeader';
export default BasicContentErrorPageHeader;
